import React, { useEffect, useRef } from 'react';
type ContactModalProps = {
  isOpen: boolean;
  onClose: () => void;
};
export function ContactModal({
  isOpen,
  onClose
}: ContactModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!isOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeButtonRef.current?.focus();
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
        return;
      }
      if (event.key !== 'Tab' || !modalRef.current) return;
      const focusable = modalRef.current.querySelectorAll<HTMLElement>('button:not([disabled]), [href]');
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first || !last) return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div ref={modalRef} className="contact-modal" role="dialog" aria-modal="true" aria-labelledby="contact-modal-title" aria-describedby="contact-modal-subtitle" data-id="element-92" data-mp="28lalx7bdeyxg">
      <section className="contact-modal__brand" aria-label="SAVIA" data-id="element-93" data-mp="1zkcnd4jpbjm9">
        <div className="contact-modal__brand-content" data-id="element-94" data-mp="1zmp5pitdfvzu">
          <p className="contact-modal__quote" data-id="element-95" data-mp="1ukzqdqz48w5y">
            El aroma no se explica.
            <br data-id="element-96" data-mp="o5z2m8k8vkag" />
            Se habita.
          </p>
          <p className="contact-modal__metadata" data-id="element-97" data-mp="o3cm3jfdlug3">
            Bogotá, Colombia · Hecho a mano
          </p>
        </div>
      </section>

      <section className="contact-modal__contact-panel" data-id="element-98" data-mp="kn9otegnyh5f">
        <button ref={closeButtonRef} type="button" className="contact-modal__close" onClick={onClose} aria-label="Cerrar contacto" data-id="element-99" data-mp="klozq4d4bqey">
          ✕
        </button>

        <div className="contact-modal__content" data-id="element-100" data-mp="glxyf6pytrw6">
          <div className="contact-modal__heading" data-id="element-101" data-mp="gkmun6wisk52">
            <h2 id="contact-modal-title" data-id="element-102" data-mp="1xjwqz4ac9h7">Escríbenos</h2>
            <p id="contact-modal-subtitle" className="contact-modal__subtitle" data-id="element-103" data-mp="1vz2zbpsouke">
              Respondemos en 24 horas hábiles · Bogotá, Colombia
            </p>
          </div>

          <div className="contact-modal__cards" data-id="element-104" data-mp="3p318bxg7fndj">
            <a className="contact-card" href="https://instagram.com/savia.ritualco" target="_blank" rel="noopener noreferrer" data-id="element-105" data-mp="3t3l16otqw4tv">
              <span className="contact-card__label" data-id="element-106" data-mp="3f66algrr9r0b">Instagram</span>
              <span className="contact-card__detail" data-id="element-107" data-mp="3k2dhpcvw18ju">@savia.ritualco</span>
              <span className="contact-card__arrow" aria-hidden="true" data-id="element-108" data-mp="30i66xe05c42a">
                →
              </span>
            </a>

            <a className="contact-card" href="https://wa.me/573213396782" target="_blank" rel="noopener noreferrer" data-id="element-109" data-mp="2vjuwb1211pj0">
              <span className="contact-card__label" data-id="element-110" data-mp="35fen591qhy0w">WhatsApp</span>
              <span className="contact-card__detail" data-id="element-111" data-mp="3jfh2aninqdcg">+57 321 339 6782</span>
              <span className="contact-card__arrow" aria-hidden="true" data-id="element-112" data-mp="3egw22o3ento0">
                →
              </span>
            </a>
          </div>
        </div>

        <p className="contact-modal__response-note" data-id="element-113" data-mp="3t592bx9izyob">
          Respondemos en 24 horas hábiles
        </p>
      </section>
    </div>;
}